module.exports = __webpack_public_path__ + "img/not_bookData.c05915c4.png";